import {API_URL} from "./index";

export async function apiGetLandingMoods() {
    const res = await fetch(`${API_URL}/landing/moods`);
    return res.json();
}

export async function apiGetLandingThreads() {
    const res = await fetch(`${API_URL}/landing/threads`);
    return res.json();
}

export async function apiGetLandingStats() {
    const res = await fetch(`${API_URL}/landing/stats`);
    return res.json();
}
